import Vue from 'vue'
import VueI18n from 'vue-i18n'
import {CURRENT_LOCALE, DEFAULT_LANG} from "./config/locale_config";

Vue.use(VueI18n)

export default new VueI18n({
  locale: CURRENT_LOCALE,
  fallbackLocale: DEFAULT_LANG,
  messages: {
    en: require('./locales/en.json'),
    uk: require('./locales/uk.json'),
  }
})
